import { AlertTriangle } from "lucide-react"
import type { LineChange } from "@/lib/api"

/** Marca de linha alterada na última edição do Shopify: novo / antes → depois / removido. */
export function LineChangeBadge({ change }: { change: LineChange | undefined }) {
  if (!change) return null
  const text =
    change.before == null
      ? "Novo na edição"
      : change.after == null
        ? `Removido na edição (era ${change.before})`
        : `Alterado na edição: ${change.before} → ${change.after}`
  return (
    <span
      title="Alteração feita no Shopify"
      className="mt-1 inline-flex items-center gap-1 rounded-md border border-amber-400 bg-amber-50 px-1.5 py-0.5 text-[11px] font-semibold text-amber-800"
    >
      <AlertTriangle className="size-3" />
      {text}
    </span>
  )
}
